// 🔧 AppPromoMessage.js
// ✅ Purpose: Reusable call-to-action component for spreading app awareness
// ✅ Features:
// - Encourages users to share the app and explore the homepage
// - Promotes signup for updates via mailing list or social media
// - Styled with white background, dark text, and strong callout feel

import React from "react";
import SubscribeForm from "./SubscribeForm";

const AppPromoMessage = () => {
  return (
    <section className="py-5 bg-white text-dark border-top border-bottom">
      <div className="container">
        <h2 className="mb-3">📣 Spread the Word!</h2>
        <p className="lead">
          Love what this app is doing? Tell your friends! 🗳️ This platform helps people vote,
          engage, and connect with local events. Tap the <strong>Learn More</strong> button to explore the features.
        </p>
        <p>
          Want to stay in the loop about upcoming events near you? 📬 Join our mailing list or follow us
          on social media — we'll keep you updated with voting opportunities and local happenings!
        </p>

        {/* 🔗 Add links when available */}
        <div className="mt-4">
          <a href="/" className="btn btn-outline-dark me-3">🏠 Learn More</a>
          <SubscribeForm />
        </div>
        
      </div>
    </section>
  );
};

export default AppPromoMessage;
